export default {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};



// WEBPACK FOOTER //
// ./src/config/initialState.js